module.exports = __webpack_public_path__ + "static/media/unbind-icon.1304c5ef.svg";